import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useState } from 'react';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { tutorialVideos } from './TutorialVideos.utils';
export function useTutorialVideos() {
    const videosData = useStore(selectors.user.videos);
    const { setUserVideos, api } = useStoreActions();
    const markWatchedVideos = (allVideos, videosData)=>allVideos.map((video)=>{
            var _videosData_video_id;
            return _object_spread_props(_object_spread({}, video), {
                watched: (_videosData_video_id = videosData[video.id]) === null || _videosData_video_id === void 0 ? void 0 : _videosData_video_id.watched
            });
        });
    const [videos, setVideos] = useState(markWatchedVideos(tutorialVideos, videosData));
    useEffect(()=>{
        setVideos(markWatchedVideos(tutorialVideos, videosData));
    }, [
        videosData
    ]);
    const handleWatch = async (video)=>{
        setUserVideos(_object_spread_props(_object_spread({}, videosData), {
            [video.id]: {
                watched: true
            }
        }));
        await api.video.markVideoAsWatched(video.id);
    };
    return {
        videos,
        handleWatch
    };
}
